import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest, call, put } from 'redux-saga/effects';
import { finishLoading, startLoading } from '../loading';
import * as chanceApi from '../../lib/api/chance';

const [
  LIST_CHANCE_COSTS,
  LIST_CHANCE_COSTS_SUCCESS,
  LIST_CHANCE_COSTS_FAILURE,
] = createRequestActionTypes('chance/LIST_CHANCE_COSTS');

export const listChanceCosts = createAction(LIST_CHANCE_COSTS, (id) => id);
const listChanceCostsSaga = createRequestSaga(
  LIST_CHANCE_COSTS,
  chanceApi.getCosts,
);

const UNLOAD_COSTS = 'chance/UNLOAD_COSTS';
export const unloadCosts = createAction(UNLOAD_COSTS);

// function* listChanceCostsSaga(action) {
//   yield put(startLoading(LIST_CHANCE_COSTS));
//   //파라미터로 action을 받아오면 액션의 정보를 조회 할 수 있다.
//   try {
//     //call 사용하면 Promise함수를 반환하는 함수를 호출하고 기다릴 수 있다.
//     //첫번째 파라미터 함수는, 나머지 파라미터는 해당 함수에 넣을 인수이다.
//     const res = yield call(chanceApi.getCosts, action.payload); //api.login(action.payload)의 의미
//     let totalPurchase = 0;
//     let totalSales = 0;

//     const costs = res.data.list;
//     costs.map((cost) => {
//       totalPurchase += Number(cost?.buyVal);//매입
//       totalSales += Number(cost?.saleVal);//매출액
//     });

//     //총 예상이익률
//     let profit = Number(totalSales) - Number(totalPurchase);
//     let totalProfit = (profit === 0) ? 0 : (Number(totalSales - totalPurchase) / Number(totalSales)) * 100;

//     yield put({
//       type: LIST_CHANCE_COSTS_SUCCESS,
//       payload: {
//         costs: costs,
//         totalPurchase: totalPurchase,
//         totalSales: totalSales,
//         totalProfit: totalProfit,
//       },
//     });
//   } catch (e) {
//     yield put({
//       type: LIST_CHANCE_COSTS_FAILURE,
//       payload: e,
//       error: true,
//     });
//   }
//   yield put(finishLoading(LIST_CHANCE_COSTS));
// }

export function* chanceCostsSaga() {
  yield takeLatest(LIST_CHANCE_COSTS, listChanceCostsSaga);
}

const initialState = {
  costs: null,
  // totalPurchase: null,
  // totalSales: null,
  // totalProfit: null,
  error: null,
};

const chanceCosts = handleActions(
  {
    [LIST_CHANCE_COSTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      costs: data.list.map((cost) => ({
        id: cost.expUuid,
        masterTyp: cost.masterTyp,
        expUuid: cost.expUuid,
        prjUuid: cost.prjUuid,
        productUuid: cost.productUuid,
        productNm: cost.productNm,
        mntDt: cost.mntDt,
        mntStDt: cost.mntStDt,
        priceUuid: cost.priceUuid,
        priceVal: Number(cost.priceVal),
        priceValIn: Number(cost.priceValIn),
        unitVal: cost.unitVal,
        unitValIn: cost.unitValIn,
        expCnt: Number(cost.expCnt),
        saleVal: Number(cost.saleVal),
        saleValIn: Number(cost.saleValIn),
        salePct: cost.salePct, //이익류
        salePctIn: cost.salePctIn, //이익류
        saleProfit: Number(cost.saleProfit), //매출이익
        saleProfitIn: Number(cost.saleProfitIn), //매출이익
        buyVal: Number(cost.buyVal),
        partnerUuid: cost.partnerUuid,
        partnerNm: cost.partnerNm,
        sellPartnerUuid: cost.sellPartnerUuid,
        sellPartnerNm: cost.sellPartnerNm,
        productDesc: cost?.productDesc,
        productUnit: cost.productUnit,
        itemCd: cost?.itemCd,
        crtUsr: cost.crtUsr,
        crtNm: cost.crtNm,
        crtDt: cost.crtDt,
        purchaseType: cost.purchaseType,
        salesType: cost.salesType,

      })),
      error: null,
    }),
    [LIST_CHANCE_COSTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_COSTS]: () => initialState,
  },
  initialState,
);

export default chanceCosts;
